import { ActionIcon } from "@mantine/core"
import { DateTimePicker, type TimeInputProps } from "@mantine/dates"
import dayjs from "dayjs"
import { useRef } from "react"
import { icons } from "../utils"

export default function DateTimeInput(params) {
  const ref = useRef<HTMLInputElement>(null)
  const { onChange, value, ...props } = params

  return (
    <DateTimePicker
      value={value}
      popoverProps={{ withinPortal: true }}
      onChange={(value) => {
        onChange(value ? dayjs(value).valueOf() : value)
      }}
      timeInputProps={
        {
          ref,
          rightSection: (
            <ActionIcon onClick={() => ref.current?.showPicker()}>
              <icons.Time size="1rem" stroke={1} />
            </ActionIcon>
          ),
        } as unknown as TimeInputProps
      }
      {...props}
    />
  )
}
